import MAX_PAGE_NUMBER_SHOWN from '../../models/maxPageNumberShown';
import ROWS_PER_PAGE from '../../models/rowsPerPage';

class PaginationBarController {
  constructor() {}

  setDisplayedPageNumbers() {
    this.pageNumber = 1;
    this.setRowCount();
    this.setNumberOfPages();
    this.setNumberOfDisplayedPages();
    this.populateDisplayedPageNumbers();
  }

  setRowCount() {
    if (this.tableComponent.tableData.content) {
      this.rowCount = this.tableComponent.getRowCount();
    }
  }

  setNumberOfPages() {
    this.numberOfPages = Math.ceil(this.rowCount / ROWS_PER_PAGE);
  }

  setNumberOfDisplayedPages() {
    this.numberOfDisplayedPageNumbers = (this.rowCount > MAX_PAGE_NUMBER_SHOWN) ? MAX_PAGE_NUMBER_SHOWN : this.rowCount;
  }

  populateDisplayedPageNumbers() {
    this.displayedPageNumbers = [];

    for (var i = 0; i < this.numberOfDisplayedPageNumbers; i++) {
      let pageNumber = this.pageNumber + i;
      this.displayedPageNumbers.push(pageNumber);

      if (this.numberOfPages === pageNumber) {
        break;
      }
    }
  }

  nextPage() {
    this.incrementPageNumber();

    if (this.lastDisplayedPageWasSelectedPage()) {
      this.shiftDisplayedPageNumbersUp();
    }
  }

  incrementPageNumber() {
    this.pageNumber++;
    this.tableComponent.addParam('pageNumber', this.pageNumber);
  }

  lastDisplayedPageWasSelectedPage() {
    return (this.displayedPageNumbers[MAX_PAGE_NUMBER_SHOWN - 1] + 1 === this.pageNumber);
  }

  shiftDisplayedPageNumbersUp() {
    for (var i = 0; i < this.displayedPageNumbers.length; i++) {
      this.displayedPageNumbers[i] += 1;
    }
  }

  previousPage() {
    this.deincrementPageNumber();

    if (this.firstDisplayedPageWasSelectedPage()) {
      this.shiftDisplayedPageNumbersDown();
    }
  }

  deincrementPageNumber() {
    this.pageNumber--;
    this.tableComponent.addParam('pageNumber', this.pageNumber);
  }

  firstDisplayedPageWasSelectedPage() {
    return (this.displayedPageNumbers[0] - 1 === this.pageNumber);
  }

  shiftDisplayedPageNumbersDown() {
    for (var i = 0; i < this.displayedPageNumbers.length; i++) {
      this.displayedPageNumbers[i] -= 1;
    }
  }

  canGoToPreviousPage() {
    return (this.pageNumber > 1);
  }

  canGoToNextPage() {
    return (this.pageNumber < this.rowCount);
  }

  setPageNumber(pageNumber) {
    this.pageNumber = pageNumber;
    this.tableComponent.addParam('pageNumber', this.pageNumber);
  }

  isSelected(pageNumber) {
    return (this.pageNumber === pageNumber);
  }
}

PaginationBarController.$inject = [];

export default PaginationBarController;



// WEBPACK FOOTER //
// ./app/components/paginationBar/paginationBar.controller.js